import { render, staticRenderFns } from "./WFCommonNode.vue?vue&type=template&id=5a682d40&scoped=true"
import script from "./WFCommonNode.vue?vue&type=script&lang=js"
export * from "./WFCommonNode.vue?vue&type=script&lang=js"
import style0 from "./WFCommonNode.vue?vue&type=style&index=0&id=5a682d40&prod&scoped=true&lang=less"
import style1 from "./WFCommonNode.vue?vue&type=style&index=1&id=5a682d40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a682d40",
  null
  
)

export default component.exports